import * as React from 'react';
import { useContext } from 'react';
import Dropzone from 'react-dropzone-uploader';
import { isFunction } from "../helpers/utils";
import { ContextUrls } from "../state/contextUrlApi";

export default function Upload({objId, onComplete}) {
	const urls = useContext(ContextUrls);

	// specify upload params and url for your files
	const getUploadParams = ({file, meta}) => {
		//console.log(meta);

		let toReturn = {
			url: urls.asset.url,
			method: 'POST',
		};

		if (objId) {
			toReturn.fields = { objId: objId };
		}

		return toReturn;
	}

	// called every time a file's `status` changes
	const handleChangeStatus = ({ meta, file, remove, xhr }, status) => {
		if (status === 'done' && isFunction(onComplete)) {
			const asset = JSON.parse(xhr.responseText)
			//console.log(status, asset);
			onComplete(asset);
			remove();
		}
	}

	return (<>
		<Dropzone
			getUploadParams={getUploadParams}
			onChangeStatus={handleChangeStatus}
			accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
					application/vnd.openxmlformats-officedocument.wordprocessingml.document,
					application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
					application/vnd.openxmlformats-officedocument.presentationml.presentation,
					text/plain,
					application/pdf,
					image/*, video/*, audio/*"
			styles={{dropzone: {overflow: 'visible', minHeight: 150}}}
			canRemove={false}
			canRestart={false}
			inputWithFilesContent={null}
			submitButtonDisabled={true}
			inputContent={() =>{ return (<><u>Upload a file</u>&nbsp;or drag and drop</>); }}
		/>
		{/*<Dump value={urls}/>*/}
		{/*<Dump value={objId}/>*/}
	</>);
}
